export function isSafari(): boolean {

    return !!(navigator && navigator.userAgent && /^((?!chrome|android).)*safari/i.test(navigator.userAgent))
}